// ** Next
import Link from "next/link";

// ** MUI
import ArticleIcon from "@mui/icons-material/Article";
import {
  Card,
  CardContent,
  Grid2 as Grid,
  Typography,
  Box,
} from "@mui/material";

function TopicCard({ name, slug }) {
  return (
    <Card spacing={3} sx={{ borderRadius: "15px", marginBottom: "14px" }}>
      <CardContent
        sx={{ padding: "0px!important", textDecoration: "none" }}
        component={Link}
        href={`/blog/topic/${slug}`}
      >
        <Grid container spacing={1}>
          <Grid
            size={{ xs: 3 }}
            sx={{
              backgroundColor: "rgb(226, 232, 240)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "rgb(113, 128, 150)",
              cursor: "pointer",
              "&:hover": {
                color: "#ffffff", // Hover text color
                backgroundColor: "#667EEA",
              },
            }}
          >
            <ArticleIcon
              sx={{
                fontSize: "24px",
                fontWeight: 700,
                cursor: "pointer",
                marginLeft: "5px",
                marginRight: "5px",
              }}
            />
          </Grid>
          <Grid size={{ xs: 9 }}>
            <Typography
              sx={{
                color: "rgb(113, 128, 150)",
                fontWeight: 600,
                fontSize: "16px",
                padding: "18px 7px",
              }}
            >
              {name}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default TopicCard;
